import { MultiTradeInActions } from './actions';

/**
 * Action creator to add a new trade-in to the list
 */
export const addTradeIn = () => {
    return {
        type: MultiTradeInActions.ADD_TRADE_IN
    };
};

/**
 * Action creator to toggle the accordion state of a specific trade-in
 * @param targetIndex - The index of the trade-in to toggle
 */
export const toggleAccordionState = (targetIndex: number) => {
    return {
        type: MultiTradeInActions.TOGGLE_ACCORDION,
        payload: { targetIndex }
    };
};

/**
 * Action creator to set the active trade-in index
 * @param activeIndex - The index to set as active
 */
export const setActiveIndex = (activeIndex: number) => {
    return {
        type: MultiTradeInActions.SET_ACTIVE_INDEX,
        payload: { activeIndex }
    };
};
